import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteStageTemplate } from "@/adapters/api";

export function useDeleteStageTemplate() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (templateId: string) => deleteStageTemplate(templateId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["stage-templates"] });
		},
	});
}
